import { User } from 'firebase/auth';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { database } from '../../config/firebase';
import {
  currentUserResourceSchema,
  CurrentUserResourceType,
} from './currentUserSchema';
import { UserProfileType } from '../userProfileSchema';

export let deserializeCurrentUser = async ({
  user,
  claims,
}: {
  user: undefined | null | User;
  claims?: Record<string, unknown>;
}) => {
  if (!user) return user;

  let userDocSnap = await getDoc(doc(database, 'users', user.uid));
  let isAdmin = typeof claims?.admin === 'boolean' ? claims.admin : false;

  let authProvider = user.providerData[0].providerId;

  let data = userDocSnap.exists() ? userDocSnap.data() || {} : {};
  return currentUserResourceSchema.parse({
    ...data,
    id: user.uid,
    handle: (data.handle || '').toLowerCase(),
    isAdmin,
    authProvider,
  });
};

export let getIsHandleTaken = async (handle?: string) => {
  if (!handle) return undefined;

  let usersQuery = query(
    collection(database, 'users'),
    where('handle', '==', handle.toLowerCase().trim())
  );
  let result = await getDocs(usersQuery);

  return Boolean(result.docs.length);
};

export let getIsProfileFinished = (user: CurrentUserResourceType | UserProfileType) =>
  Boolean(user && user.handle && user.avatarId);
